export interface AppState {
  value: number;
  isLoading: boolean;
  connected: boolean;
  jwt?: string | null;
  user?: User | null;
  dialog: DialogType | null
}

export interface User {
  email: string;
  id: number;
  profile: UserProfile;
}


export interface UserProfile {
  id: number;
  firstName: string;
  lastName: string;
  country: string;
  state?: string;
  address_1: string;
  address_2?: string;
  zip: string | number;
}

export enum DialogType {
  Signup = "signup",
  Login = "login",
  Profile = "profile",
  Forgot = "forgot",
  Purchases = "purchases"
}
